import { render, staticRenderFns } from "./detail-component-dashboard.vue?vue&type=template&id=2e71e835&scoped=true"
import script from "./detail-component-dashboard.vue?vue&type=script&lang=ts"
export * from "./detail-component-dashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e71e835",
  null
  
)

export default component.exports